export default __webpack_public_path__ + "static/media/AcheronianStrongholdMap.0eb5ca96.jpg";